/**
 * @name bridge
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgOS43MjhWMTYiIC8+CiAgPHBhdGggZD0iTTE0IDkuNzI4VjE2IiAvPgogIDxwYXRoIGQ9Ik0xOCAyMFY0IiAvPgogIDxwYXRoIGQ9Im0yMiAxMS00LTRBNy41IDcuNSAwIDAgMSA2IDdsLTQgNCIgLz4KICA8cGF0aCBkPSJNMjIgMTZIMiIgLz4KICA8cGF0aCBkPSJNNiAyMFY0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/bridge
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Bridge: string = `
<svg
  class="lucide lucide-bridge"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 9.728V16" />
  <path d="M14 9.728V16" />
  <path d="M18 20V4" />
  <path d="m22 11-4-4A7.5 7.5 0 0 1 6 7l-4 4" />
  <path d="M22 16H2" />
  <path d="M6 20V4" />
</svg>
`;

export default Bridge;
